/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import axios from 'axios';
import jwt from 'jsonwebtoken';
import Bowser from 'bowser';
import simpleJWT from 'jwt-simple';
import { closelightbox } from '../util/Functions';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fpPromise = FingerprintJS.load()

let urlLogin = `http://${window.location.hostname}:3001/session`;
let urlService = `http://${window.location.hostname}:3002/service/s`

if(!process.env.REACT_APP_LOCAL){
    urlLogin = `https://${window.location.hostname}/session`;
    urlService = `https://${window.location.hostname}/service/s`
}

if(process.env.REACT_APP_ENV == 'dev'){
    urlLogin = 'https://indigo-next-gateway.dev-albo.tech/session'; 
    urlService = 'https://indigo-next-gateway.dev-albo.tech/service/s';
}

if(process.env.REACT_APP_ENV == 'qa'){
    urlLogin = 'https://indigo-next-gateway.qa-albo.tech/session'; 
    urlService = 'https://indigo-next-gateway.qa-albo.tech/service/s';
}

if(process.env.REACT_APP_ENV == 'sbx'){
    urlLogin = 'https://indigo-next-gateway.sbx-albo.tech/session'; 
    urlService = 'https://indigo-next-gateway.sbx-albo.tech/service/s';
}

if(process.env.REACT_APP_ENV == 'prod'){
    urlLogin = 'https://peripheral-app-mirai.albo.live/in/session'; 
    urlService = 'https://peripheral-app-mirai.albo.live/in/service/s';
}

let count;
const Timer = (token, history) => {
    let time = jwt.decode(token)
    let timeleft = (time.exp * 1000) - Math.floor(Date.now());
    function timeOut(){
        closelightbox()
        history.push("/login", {sessionClosed: true})
    }
    let startTimer = function() {
        window.clearTimeout(count);
        count = setTimeout(timeOut, timeleft);
    }
    if(timeleft){
        startTimer()
    }
}

const createBodyLogin = (user, pos) => {
    let body = {
        email: user.email,
        provider: user.provider,
        avatar: user.picture,
    };

    if(pos.lat){
        body['lat'] = parseFloat(pos.lat);
    }

    if(pos.lon){
        body['lon'] = parseFloat(pos.lon);
    }

    return body;
}

const createTokenFp = async () => {
    let fp = await fpPromise
    let result = await fp.get()
    let tokenFp = simpleJWT.encode(result.visitorId, 'RS256');
    return tokenFp
}

export const login = async (user, pos, history) => {
    let body = createBodyLogin(user, pos);
    let device = await createTokenFp()
    let response = await axios({
        url: `${urlLogin}/login`,
        method: 'POST',
        data: body,
        headers: {
            emaildomain: user.hd,
            fp: device
        }
    }).then((response) => {
        Timer(response.data.token, history)
        return response;
    }).catch((error) => {
        return error.response;
    });

    return response;
}

export const auth = async (pos) => {
    let sessionData = localStorage?.session ? JSON.parse(localStorage?.session) : {};
    let device = sessionData.fp || (await createTokenFp());
    let token = sessionData.token;
    let session = sessionData.session;
    let response = await axios({
        url: `${urlLogin}/auth`,
        method: 'POST',
        headers: {
            token: token,
            Authorization: `Bearer ${token}`,
            session: session,
            fp: device
        },
        data: pos
    }).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });

    return response;
}

export const logout = async () => {
    let sessionData = localStorage?.session ? JSON.parse(localStorage?.session) : {};
    let device = sessionData.fp || (await createTokenFp());
    let token = sessionData.token;
    let session = sessionData.session;
    let response = await axios({
        url: `${urlLogin}/logout`,
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            session: session,
            fp: device
        }
    }).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });

    return response;
}

export const getIP = async () => {
    let ip = '0.0.0.0';
    let response = await axios({
        url: `https://api.ipify.org`,
        method: 'GET',
        timeout: 1000
    }).then((data) => {
        return data.data;
    }).catch((error) => {
        //console.log(error);
        //return error.response.data;
        return false;
    });

    if(!response){
        return ip;
    }
    /*let response = await axios({
        url: `https://ipv4.icanhazip.com`,
        method: 'GET',
    }).then((data) => {
        return data.data;
    }).catch((error) => {
        return error.response.data;
    });*/

    return response;
}

export const service = async (widgetName, data, pos, changeAlert, changeLoader, history) => {
    if (history) {
        validateSession(pos, history);
    }
    let factor = '';

    if(data && data.customerUuid){
        let factors = localStorage?.factors ? JSON.parse(localStorage?.factors) : {};
        if(factors.hasOwnProperty(data.customerUuid)){
            factor = factors[data.customerUuid];
        }
        data.factor_uuid = factor;
    }


    const request = makeRequest(widgetName, data);
    let sessionData = localStorage?.session ? JSON.parse(localStorage?.session) : {};
    let device = sessionData.fp || (await createTokenFp());
    let token = sessionData.token;
    let session = sessionData.session;
    let jsonWT = sessionData.device || '';
    let response = await axios({
        url: `${urlService}/${session}`,
        method: 'POST',
        headers: {
            token: token,
            Authorization: `Bearer ${token}`,
            device: jsonWT,
            fp: device
        },
        data: request
    }).then((data) => {
        return data;
    }).catch((error) => {
        return error.response;
    });
    alert(response, changeAlert, changeLoader, pos, history)
    return response;
}

const makeRequest = (widgetName, data) => {
    let request = {
        data: {
            command: {
                type: widgetName,
            }
        }
    }

    request.data[widgetName] = {
        text: data,
        language: 'es-mx'
    };

    return request;
}

const alert = (response, changeAlert, changeLoader, pos, history) => {
    if (response?.status === 200) {
        if (response.data.data.response === 'BAD') {
            changeAlert(true, 'error', 'Error: ' + response.data.data.message);
        }
    } else if (response.status === 502) {
        changeAlert(true, 'error', 'Error con la conexión, intenta nuevamente');
    } else if (response.status === 503) {
        changeAlert(true, 'error', 'Error: ' + response.data.message);
    } else if (response.status === 410) {
        history.push("/login", {sessionClosed: true})
    } else if (response.status === 401) {
        changeAlert(true, 'error', 'Error: ' + response.data.message);
    } else {
        changeAlert(true, 'error', 'Error non parsed');
    }
}

export const validateSession = async (pos, history) => {
  let a = await auth(pos);

  if (a?.status != 200) {
    delete localStorage?.session;
    delete localStorage?.factors;
    history.push('/login');
  } else {
    Timer(a.data.token, history)
    let info = JSON.parse(localStorage?.session);
    info['token'] = a.data.token;
    info['device'] = a.data.device;
    info['fp'] = a.data.fp;
    localStorage.session = JSON.stringify(info);
  }
}

export const option = async (data, pos) => {
    let sessionData = JSON.parse(localStorage?.session);
    let token = sessionData['token'];
    let session = sessionData['session'];
    let jsonWT = sessionData['device'] || '';
    let device = sessionData['fp'] || (await createTokenFp());

    let response = await axios({
        url: `${urlService}/${session}`,
        method: 'OPTIONS',
        headers: {
            token: token,
            Authorization: `Bearer ${token}`,
            device: jsonWT,
            fp: device,
        },
    }).then((data) => {
        return data;
    }).catch((error) => {
        return error.response;
    });

    return response;
}

export const dialogflow = async (data, pos) => {
    let sessionData = JSON.parse(localStorage?.session);
    let token = sessionData['token'];
    let session = sessionData['session'];
    let jsonWT = sessionData['device'] || '';
    let device = sessionData['fp'] || (await createTokenFp());

    let response = await axios({
        url: `${urlService}/${session}`,
        method: 'POST',
        headers: {
            token: token,
            Authorization: `Bearer ${token}`,
            device: jsonWT,
            fp: device,
        },
        data: data
    }).then((data) => {
        return data;
    }).catch((error) => {
        return error.response;
    });

    return response;
}
//newToken = await generateJWT(user.g, session.priKey);
const createToken = async (pos) => {
    let info = await infoNav(pos);
    let data = {
        c: info,
        iat: new Date().getTime()
    }

    let token = simpleJWT.encode(data, 'RS256');
    return token;
}

const infoNav = async (pos) => {
    if(!pos.hasOwnProperty('lat')){
        pos['lat'] = 0
    }

    if(!pos.hasOwnProperty('lon')){
        pos['lon'] = 0
    }
    let b = Bowser.parse(navigator.userAgent);
    let t = `${b.platform.type}`;
    let n = b.browser.name;
    let v = b.browser.version;
    let o = `${b.os.name} ${b.os.versionName}`;
    let g = {
        lt: pos.lat,
        ln: pos.lon
    };
    let ip = await getIP();
    //let ip = localStorage?.myIp;
    //let ip = await publicip.v4();
    let ipString = 'ipv4';
    if(ip){
        ipString = `ipv4-${ip}`;
    }

    return {
        t: t,
        n: n,
        v: v,
        g: g,
        o: o,
        i: ipString
    }
}